import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { PostComposer } from '@/components/Post';
import type { PostSubmitData } from '@/components/Post/PostComposer';
import api from '@/utils/api';
import './CreatePost.scss';

interface LocationState {
  from?: string;
  profileId?: number;
}

const CreatePostPage: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useLocation() as { state: LocationState | null };
  const from = state?.from || '/feed';
  const profileId = state?.profileId;

  const handleSubmit = async (data: PostSubmitData) => {
    await api.post('/posts', {
      body: data.body,
      mediaUrl: data.mediaUrl,
      locationId: data.locationId,
      viewType: data.viewType,
      ppvPrice: data.ppvPrice,
      ppvTokenId: data.ppvTokenId,
      postId: data.postId,
      // PPV preview controls (#257). Dropping these here is why
      // every PPV post was landing as char_limit/200 on the server
      // regardless of what the composer picker showed.
      previewMode: data.previewMode,
      previewCharLimit: data.previewCharLimit,
      // Creator-declared AI generation flag (#531).
      isAiGenerated: data.isAiGenerated,
    });
    navigate(from, { state: { postCreated: true }, replace: true });
  };

  return (
    <div className="create-post-page">
      <div className="create-post-container">
        <header className="create-post-header">
          <button
            className="create-post-back"
            onClick={() => navigate(from)}
            aria-label="Back"
          >
            <FaArrowLeft />
          </button>
          <h1>New Post</h1>
        </header>

        <PostComposer onSubmit={handleSubmit} profileId={profileId} />
      </div>
    </div>
  );
};

export default CreatePostPage;
